import { render, staticRenderFns } from "./InboxFilter.vue?vue&type=template&id=6c81b281&"
import script from "./InboxFilter.vue?vue&type=script&lang=js&"
export * from "./InboxFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports